import axios from "axios";
import { del, get, post, patch,  put } from "./pre_registration_rejections_api_helper";
import * as url from "./pre_registration_rejections_url_helper";





// Get features
export const getPreRegistrationRejections = () => get(url.GET_PRE_REGISTRATION_REJECTIONS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewPreRegistrationRejection = (preRegistrationRejection) => post(url.ADD_NEW_PRE_REGISTRATION_REJECTION, preRegistrationRejection);


// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updatePreRegistrationRejection = (preRegistrationRejection) => patch(`${url.UPDATE_PRE_REGISTRATION_REJECTION}/${preRegistrationRejection.id}`,  PreRegistrationRejection);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deletePreRegistrationRejection = (preRegistrationRejection) => del(`${url.DELETE_PRE_REGISTRATION_REJECTION}/${preRegistrationRejection.id}`);







export {
  //getLoggedInUser,
  
  
};
